import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { PreloginProduct } from '../../biometrics-registration-wizard/models/models';

@Component({
    selector: 'app-registration-product-information-list',
    templateUrl: './registration-product-information-list.component.html',
    styleUrls: ['./registration-product-information-list.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class RegistrationProductInformationListComponent implements OnInit {

	@Input()
	public preloginProductList: Array<PreloginProduct>;

	constructor() { }

	public ngOnInit(): void {
	}

}
